/* Search overlay 2026 — ENG-7580 (default search)
 * Activates when body.search-2026 is present. The class is applied unconditionally in
 * theme.liquid, so this is the site-wide default; the legacy modal is intercepted.
 * Vanilla JS, no custom element conflicts.
 */
(function () {
  'use strict';

  /* ── Static taxonomy ──
   * Families are a static taxonomy (deferred — no per-product family data yet).
   * Bestsellers / categories come from real settings via the embedded
   * #SearchOverlay2026Data JSON block (see DATA below). */
  var FAMILIES = [
    { name: 'Ambery',  desc: 'Resin, warmth, depth',     g: '551' },
    { name: 'Citrus',  desc: 'Bright, sharp, lifted',    g: '144' },
    { name: 'Floral',  desc: 'Jasmine, rose, peony',     g: '271' },
    { name: 'Fruity',  desc: 'Pear, fig, apple, juice',  g: '307' },
    { name: 'Green',   desc: 'Basil, herbal clarity',    g: '008' },
    { name: 'Musky',   desc: 'Skin-close, intimate',     g: '232' },
    { name: 'Vanilla', desc: 'Warm, creamy, gourmand',   g: '057' },
    { name: 'Woody',   desc: 'Sandalwood, cedar, depth', g: '441' }
  ];

  /* Real data loaded from the embedded JSON block (server-side, from theme settings). */
  var DATA = { bestsellers: [], categories: [] };

  /* ── DOM refs (set in setup()) ── */
  var overlay, input, clearBtn, closeBtn, body;

  /* Element focused before the overlay opened — focus returns here on close (a11y). */
  var lastTrigger = null;

  /* ── Boost headless search state ── */
  var shopDomain = '';        // shop.permanent_domain, from the overlay data-shop attr
  var boostAbort = null;      // AbortController for the in-flight suggest request
  var BOOST_SUGGEST_URL = 'https://services.mybcapps.com/bc-sf-filter/search/suggest';

  /* ── Helpers ── */
  function escapeReg(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /* HTML-escape any value before it lands in innerHTML or an attribute. The query is fully
     attacker-controllable (typed or seeded via a shared deep link) and Boost product data is
     interpolated too, so every string built into markup runs through here. */
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function highlight(str, q) {
    // Escape the haystack first; match in escaped space (escape the needle too) so the output
    // is always safe markup and the `<span class="hl">` wrap can't be broken out of.
    var safe = escapeHtml(str);
    if (!q) return safe;
    try {
      var re = new RegExp('(' + escapeReg(escapeHtml(q)) + ')', 'ig');
      return safe.replace(re, '<span class="hl">$1</span>');
    } catch (e) {
      return safe;
    }
  }

  function getGradientVar(n) {
    /* Map family SKU number to a CSS gradient var defined in search-2026.css under .search-2026 */
    var gradientMap = {
      '008': 'var(--so-g-008)', '057': 'var(--so-g-057)', '144': 'var(--so-g-144)',
      '232': 'var(--so-g-232)', '271': 'var(--so-g-271)', '307': 'var(--so-g-307)',
      '441': 'var(--so-g-441)', '551': 'var(--so-g-551)', '619': 'var(--so-g-619)',
      '866': 'var(--so-g-866)'
    };
    return gradientMap[n] || 'var(--so-sand)';
  }

  function cartAddUrl() {
    // window.routes.cart_add_url is the bare `/cart/add` (locale-prefixed), which returns the
    // HTML cart page — response.json() then throws "Unexpected token '<'". Only the `.js` AJAX
    // endpoint returns JSON, so ensure the suffix while preserving any locale prefix.
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.slice(-3) === '.js' ? base : base + '.js';
  }

  function section(label, count, inner) {
    return '<div class="search-section">' +
      '<div class="section-head">' +
        '<div class="section-label">' + label + '</div>' +
        '<div class="section-count">' + count + '</div>' +
      '</div>' + inner +
    '</div>';
  }

  /* ── Card / row renderers ── */

  function productCard(p, q, idx) {
    var delay = idx * 60;
    var img = p.image ? '<img class="pc-photo" src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '';
    var sub = p.type ? '<div class="pc-notes">' + highlight(p.type, q) + '</div>' : '';
    var available = p.available !== false;
    var atc = available
      ? '<button class="pc-atc" type="button" data-variant-id="' + escapeHtml(p.variant_id) + '">Quick add</button>'
      : '<button class="pc-atc" type="button" disabled aria-disabled="true">Sold out</button>';
    return '<a href="' + escapeHtml(p.url || '#') + '" class="product-card" style="animation-delay:' + delay + 'ms;">' +
      '<div class="pc-img">' + img + '</div>' +
      '<div class="pc-info">' +
        '<div class="pc-name">' + highlight(p.title || '', q) + '</div>' +
        sub +
        '<div class="pc-bot">' +
          '<div class="pc-price">' +
            (p.price_varies ? '<span class="pc-price-from">From</span>' : '') +
            escapeHtml(p.price || '') +
          '</div>' +
          atc +
        '</div>' +
      '</div>' +
    '</a>';
  }

  /* Family → the "our-fragrances" collection pre-filtered by the scent-family metafield. */
  function familyUrl(name) {
    return '/collections/our-fragrances?filter.p.m.custom.filter_scent_family=' +
      encodeURIComponent(name.toUpperCase()) + '&sort_by=manual';
  }

  function familyRow(f, q, idx) {
    var delay = idx * 60;
    return '<a href="' + familyUrl(f.name) + '" class="family-row" style="animation-delay:' + delay + 'ms;">' +
      '<div class="family-row-left">' +
        '<div class="family-row-dot" style="background:' + getGradientVar(f.g) + ';"></div>' +
        '<div>' +
          '<div class="family-row-name">' + highlight(f.name, q) + '</div>' +
          '<div class="family-row-desc">' + highlight(f.desc, q) + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="family-row-arrow">' +
        '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>' +
    '</a>';
  }

  /* Generic link row — kind/desc are optional (categories have them, page links don't). */
  function linkRow(item, q, idx) {
    var delay = idx * 60;
    var kind = item.kind ? '<span class="page-link-kind">' + escapeHtml(item.kind) + '</span>' : '';
    var desc = item.desc ? '<div class="page-link-desc">' + highlight(item.desc, q) + '</div>' : '';
    return '<a href="' + escapeHtml(item.url || '#') + '" class="page-link" style="animation-delay:' + delay + 'ms;">' +
      '<div>' +
        '<div class="page-link-text">' + kind +
          '<span class="page-link-title">' + highlight(item.title || '', q) + '</span>' +
        '</div>' + desc +
      '</div>' +
      '<div class="page-link-arrow">' +
        '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>' +
    '</a>';
  }

  function categoryItem(c) {
    var count = (c.product_count != null) ? (c.product_count + (c.product_count === 1 ? ' product' : ' products')) : '';
    return { title: c.title, url: c.url, kind: 'Shop', desc: count };
  }

  /* ── Render: empty state ── */
  function renderEmptyState() {
    var html = '';
    var top = DATA.bestsellers.slice(0, 4);

    if (top.length) {
      html += section('Most reached for', top.length + (top.length === 1 ? ' fragrance' : ' fragrances'),
        '<div class="result-grid">' + top.map(function (p, i) { return productCard(p, '', i); }).join('') + '</div>');
    }
    /* TODO ENG-7580: when no bestsellers collection is configured (top.length === 0),
       fetch Boost trending products here. Deferred to Phase 3 (Boost headless wiring). */

    if (DATA.categories.length) {
      html += section('Categories', DATA.categories.length + ' ways to shop',
        '<div class="page-link-list">' + DATA.categories.map(function (c, i) { return linkRow(categoryItem(c), '', i); }).join('') + '</div>');
    }

    html += section('Families', FAMILIES.length + ' families',
      '<div class="family-row-list">' + FAMILIES.map(function (f, i) { return familyRow(f, '', i); }).join('') + '</div>');

    body.innerHTML = html;
  }

  /* ── Boost headless live search ──
   * Boost is the real search engine (the page /search and the legacy modal use it via
   * its SSR/instant-search embeds). We hit its public JSON suggest API and render with our
   * own markup so ranking/synonyms/merchandising (configured in the Boost dashboard) stay
   * consistent with /search, while the look & feel is the 2026 overlay. Families are NOT a
   * Boost concept — they stay a static taxonomy filtered client-side. */

  function money(amount, meta) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    var cur = (meta && meta.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function boostImage(p) {
    if (p.images_info && p.images_info.length) {
      var first = p.images_info[0];
      return (typeof first === 'string') ? first : (first.src || first.url || '');
    }
    if (p.images) {
      if (Array.isArray(p.images)) return p.images[0] || '';
      // Boost returns images as an object: { "1": url, "2": url, ... }
      var keys = Object.keys(p.images);
      return keys.length ? p.images[keys[0]] : '';
    }
    return '';
  }

  /* Map a Boost product to the productCard() shape. Prices come in major units (e.g. 139 = $139). */
  function boostProduct(p, meta) {
    var variants = p.variants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available !== false) { variant = variants[i]; break; }
    }
    if (!variant) variant = variants[0] || {};
    var priceMin = (p.price_min != null) ? p.price_min : p.price;
    var priceMax = (p.price_max != null) ? p.price_max : priceMin;

    /* ENG-8073 — Boost's suggest API answers from its own index, which only ever holds
       catalogue prices, so the overlay would show control while every other surface shows the
       visitor's cohort. Re-derive the range from the shared table in assets/pricing-flash.js
       rather than parsing it again here: one artifact, one parser. Variants absent from the
       table keep their catalogue price, exactly as the Liquid resolver leaves them alone.
       Boost prices are major units; the table is in cents.

       The catalogue price goes IN to the lookup, not just out of it: that is what applies the
       resolver's two rails (only ever lower, floor at 40%). Without it this surface would be
       less strict than Liquid and could show a price above what the Cart Transform charges. */
    var cohort = window.nwPricingCohort ? window.nwPricingCohort() : '';
    if (cohort && window.nwPricingLookup && variants.length) {
      var cMin = null;
      var cMax = null;
      var moved = false;
      for (var c = 0; c < variants.length; c++) {
        var catPrice = parseFloat(variants[c].price);
        if (isNaN(catPrice)) continue;
        var cCents = window.nwPricingLookup(cohort, variants[c].id, Math.round(catPrice * 100));
        var cPrice = (cCents === null) ? catPrice : cCents / 100;
        if (cCents !== null) moved = true;
        if (cMin === null || cPrice < cMin) cMin = cPrice;
        if (cMax === null || cPrice > cMax) cMax = cPrice;
      }
      if (moved && cMin !== null) {
        priceMin = cMin;
        priceMax = cMax;
      }
    }

    return {
      title: p.title || '',
      url: p.url || (p.handle ? '/products/' + p.handle : '#'),
      type: p.product_type || '',
      price: money(priceMin, meta),
      price_varies: (priceMin != null && priceMax != null && priceMax !== priceMin),
      available: p.available !== false,
      variant_id: variant.id,
      image: boostImage(p)
    };
  }

  /* Debounced + abortable suggest request. */
  function runBoostSearch(q) {
    if (!shopDomain) { renderNoResults(q); return; }
    if (boostAbort) boostAbort.abort();      // cancel any in-flight request (avoids out-of-order renders)
    boostAbort = new AbortController();

    // product_limit is intentionally high so the Fragrances section shows every related match,
    // not a truncated preview. Boost's suggest endpoint may still apply its own server-side cap.
    var url = BOOST_SUGGEST_URL +
      '?shop=' + encodeURIComponent(shopDomain) +
      '&q=' + encodeURIComponent(q) +
      '&product_limit=100&collection_limit=4&page_limit=4&suggestion_limit=4&dym_limit=2&re_run_if_typo=true';

    fetch(url, { signal: boostAbort.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderBoostResults(q, data); })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;   // superseded by a newer keystroke — ignore
        renderNoResults(q);                          // network/parse failure → graceful no-results
      });
    /* TODO ENG-7580 (analytics, deferred): fire the Boost Event Tracking API
       (POST https://lambda.mybcapps.com/e) for search/click/ATC so the Boost dashboard keeps
       CTR/attribution in headless mode. Needs the store `tid` + exact event schema — capture a
       real payload from the Network tab (variant A's Boost embed already sends these) before wiring. */
  }

  function renderBoostResults(q, data) {
    data = data || {};
    var meta = data.meta || {};
    var products = data.products || [];
    var collections = data.collections || [];
    var ql = q.toLowerCase();
    var families = FAMILIES.filter(function (f) {
      return (f.name + ' ' + f.desc).toLowerCase().indexOf(ql) !== -1;
    });

    if (products.length + collections.length + families.length === 0) {
      renderNoResults(q, data.did_you_mean);
      return;
    }

    var html = '';
    if (products.length) {
      html += section('Products', String(products.length),
        '<div class="result-grid">' + products.map(function (p, i) { return productCard(boostProduct(p, meta), q, i); }).join('') + '</div>');
    }
    if (collections.length) {
      html += section('Categories', String(collections.length),
        '<div class="page-link-list">' + collections.map(function (c, i) {
          return linkRow({ title: c.title, url: c.url || ('/collections/' + c.handle), kind: 'Shop' }, q, i);
        }).join('') + '</div>');
    }
    if (families.length) {
      html += section('Families', String(families.length),
        '<div class="family-row-list">' + families.map(function (f, i) { return familyRow(f, q, i); }).join('') + '</div>');
    }
    body.innerHTML = html;
  }

  function renderNoResults(q, didYouMean) {
    var dym = '';
    if (didYouMean && didYouMean.length) {
      var term = (typeof didYouMean[0] === 'string') ? didYouMean[0] : (didYouMean[0].q || didYouMean[0].query || '');
      if (term) {
        // Escape for attribute context (an embedded `"` would break out of data-dym) and text
        // context. The click handler reads back the decoded value via getAttribute, so the
        // original term is preserved when re-running the search.
        var termSafe = escapeHtml(term);
        dym = ' Did you mean <button type="button" class="so-dym" data-dym="' + termSafe + '" style="background:none;border:0;padding:0;cursor:pointer;color:var(--so-text-headline);font-weight:500;text-decoration:underline;font:inherit;">&ldquo;' + termSafe + '&rdquo;</button>?';
      }
    }
    body.innerHTML = '<div class="no-results">' +
      '<h2 class="no-results-headline">Nothing in this name yet.</h2>' +
      '<p class="no-results-body">Nothing matches <strong style="color:var(--so-text-headline);font-weight:500;">&ldquo;' + escapeHtml(q) + '&rdquo;</strong>.' + dym + ' Try a family instead — Ambery, Citrus, Woody, Musky — or let the quiz do the listening.</p>' +
      '<div class="no-results-actions">' +
        '<button class="btn-primary" type="button" data-action="quiz">Take the quiz</button>' +
        '<button class="btn-secondary" type="button" data-action="clear">Clear search</button>' +
      '</div>' +
    '</div>';
    var clearAction = body.querySelector('[data-action="clear"]');
    var quizAction = body.querySelector('[data-action="quiz"]');
    var dymBtn = body.querySelector('.so-dym');
    if (clearAction) clearAction.addEventListener('click', function () {
      input.value = '';
      syncClear();
      input.focus();
      renderEmptyState();
    });
    if (quizAction) quizAction.addEventListener('click', function () {
      closeSearch();
      window.location.href = '/pages/quiz';
    });
    if (dymBtn) dymBtn.addEventListener('click', function () {
      var term = dymBtn.getAttribute('data-dym');
      input.value = term;
      syncClear();
      input.focus();
      runBoostSearch(term);
    });
  }

  /* ── Open the Rebuy SmartCart flyout (the site-wide "shopping bag" slider) ──
   * Rebuy does NOT intercept native fetch('/cart/add.js') calls, so after a headless add the
   * flyout must be opened explicitly to match the rest of the site. The public API has no
   * open()/refresh(): re-sync Rebuy's internal cart from Shopify (Cart.fetchShopifyCart →
   * SmartCart.setCart), then SmartCart.show(). Every step is feature-detected so a partial or
   * older Rebuy build still opens, and we wait for `rebuy:smartcart.ready` if it's mid-init.
   * Callers gate on window.Rebuy being present before invoking this. */
  function openSmartCart() {
    var rb = window.Rebuy;
    if (!rb || !rb.SmartCart) return;
    function open() {
      var sc = rb.SmartCart;
      // Open unconditionally first — show() is the stable method the header cart icon uses, so
      // the flyout always opens even if the re-sync path below is a no-op on this Rebuy build.
      // (Gating show() inside fetchShopifyCart's callback risked it never firing — and since the
      // search overlay is already closed, that left the user seeing nothing.)
      if (typeof sc.show === 'function') sc.show();
      // Best-effort: re-sync Rebuy's internal cart from Shopify so the just-added item renders.
      // Handle both the documented callback form and a Promise-returning variant.
      if (rb.Cart && typeof rb.Cart.fetchShopifyCart === 'function' && typeof sc.setCart === 'function') {
        try {
          var maybe = rb.Cart.fetchShopifyCart(function (cart) {
            try { sc.setCart(cart); } catch (e) {}
          });
          if (maybe && typeof maybe.then === 'function') {
            maybe.then(function (cart) { try { sc.setCart(cart); } catch (e) {} });
          }
        } catch (e) {}
      }
    }
    // Gate on show() being callable, not on `.status`: by the time the user adds from search,
    // Rebuy has loaded. Waiting on `rebuy:smartcart.ready` would hang if that event already
    // fired at page load (it's one-shot) or if this build doesn't expose `.status`.
    if (typeof rb.SmartCart.show === 'function') open();
    else document.addEventListener('rebuy:smartcart.ready', open, { once: true });
  }

  /* ── Quick add → real ATC, then open the cart slider (matches the rest of the site). ── */
  function quickAdd(variantId, btn) {
    if (!variantId || btn.getAttribute('aria-disabled') === 'true') return;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.setAttribute('aria-disabled', 'true');
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {            // Shopify error payload (e.g. sold out / over-quantity)
          btn.textContent = 'Sold out';
          setTimeout(function () { btn.textContent = original; btn.removeAttribute('aria-disabled'); }, 1800);
          return;
        }
        btn.removeAttribute('aria-disabled');
        if (window.Rebuy && window.Rebuy.SmartCart) {
          // Close the full-screen search overlay and open the cart slider — the flyout is
          // now the confirmation, mirroring an add-to-cart anywhere else on the site.
          closeSearch();
          openSmartCart();
        } else {
          // Rebuy not loaded — fall back to inline confirmation; the item is already in the cart.
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; }, 1800);
        }
      })
      .catch(function () {
        btn.textContent = original;
        btn.removeAttribute('aria-disabled');
      });
  }

  /* ── Focus trap ──
   * aria-modal="true" promises focus is confined to the dialog, but the overlay reimplements
   * open/close (the legacy details-modal got this free from the native element). The body
   * re-renders on every keystroke, so we recompute the focusable set on each Tab rather than
   * snapshotting it — global.js's trapFocus() caches first/last at call time and would go stale
   * here. getFocusableElements() (also global.js) is reused for the same selector. */
  function onOverlayKeydown(e) {
    if (e.key !== 'Tab') return;
    var focusables = (typeof getFocusableElements === 'function')
      ? getFocusableElements(overlay)
      : Array.prototype.slice.call(
          overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
        );
    focusables = focusables.filter(function (el) { return !el.hasAttribute('hidden') && el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ── Open / close ── */
  function openSearch() {
    if (!overlay) return;
    lastTrigger = document.activeElement;   // capture before focus moves into the overlay
    overlay.classList.add('open');
    document.body.classList.add('search-overlay-2026-open');
    renderEmptyState();
    syncClear();
    overlay.addEventListener('keydown', onOverlayKeydown);
    setTimeout(function () { if (input) input.focus(); }, 60);
  }

  function closeSearch() {
    if (!overlay) return;
    overlay.removeEventListener('keydown', onOverlayKeydown);
    overlay.classList.remove('open');
    document.body.classList.remove('search-overlay-2026-open');
    if (input) input.value = '';
    syncClear();
    // Return focus to whatever opened the overlay (header search trigger / keyboard shortcut).
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function syncClear() {
    if (!clearBtn || !input) return;
    if (input.value.length > 0) clearBtn.removeAttribute('hidden');
    else clearBtn.setAttribute('hidden', '');
  }

  function loadData() {
    var el = document.getElementById('SearchOverlay2026Data');
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent);
      DATA.bestsellers = parsed.bestsellers || [];
      DATA.categories = parsed.categories || [];
    } catch (e) { /* keep empty arrays — sections just won't render */ }
  }

  /* ── Keyboard shortcuts (global listener — check class at call time) ── */
  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('search-2026')) return;
    var o = document.getElementById('SearchOverlay2026');
    if (!o) return;

    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      if (o.classList.contains('open')) closeSearch();
      else openSearch();
    } else if (e.key === 'Escape' && o.classList.contains('open')) {
      closeSearch();
    } else if (e.key === '/' && !o.classList.contains('open') && document.activeElement === document.body) {
      e.preventDefault();
      openSearch();
    }
  });

  /* ── Setup (runs after DOM is ready) ── */
  function setup() {
    overlay  = document.getElementById('SearchOverlay2026');
    input    = document.getElementById('SearchOverlay2026Input');
    clearBtn = document.getElementById('SearchOverlay2026Clear');
    closeBtn = document.getElementById('SearchOverlay2026Close');
    body     = document.getElementById('SearchOverlay2026Body');

    if (!overlay) return;

    shopDomain = overlay.getAttribute('data-shop') || '';
    loadData();

    // Child elements are guarded individually: overlay exists (early return above), but a future
    // id rename of any child would otherwise throw here and break setup() silently.
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    if (clearBtn) clearBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (input) input.value = '';
      syncClear();
      if (input) input.focus();
      renderEmptyState();
    });

    /* Click on backdrop (not on content) closes overlay */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || (e.target && e.target.classList && e.target.classList.contains('search-overlay-inner'))) {
        closeSearch();
      }
    });

    /* Quick add — delegated. The card is an <a>, so cancel its navigation when the
       Quick add button (a descendant) is clicked. */
    if (body) body.addEventListener('click', function (e) {
      var atc = e.target && e.target.closest('.pc-atc');
      if (!atc) return;
      e.preventDefault();
      e.stopPropagation();
      quickAdd(atc.getAttribute('data-variant-id'), atc);
    });

    if (input) {
      /* Live typing — debounced */
      var typingTimer;
      input.addEventListener('input', function () {
        clearTimeout(typingTimer);
        var v = input.value;
        syncClear();
        typingTimer = setTimeout(function () {
          if (!v.trim()) {
            if (boostAbort) boostAbort.abort();
            renderEmptyState();
          } else {
            runBoostSearch(v.trim());
          }
        }, 120);
      });

      /* Enter — select first result */
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var first = body && body.querySelector('.product-card, .family-row, .page-link');
          if (first) first.click();
        }
      });
    }
  }

  /* ── Header search intercept ──
   * Registered on `window` in CAPTURE phase — window is the first node in the event path,
   * so this fires before ANY document- or element-level listener regardless of registration
   * order. This matters because Boost's search widget binds on document/descendants and opens
   * its modal on `pointerdown` (before `click`); a document-level listener loses the race.
   * We block pointerdown/mousedown (to preempt Boost) and open on click (covers keyboard
   * activation of the <summary>). stopImmediatePropagation stops the event from ever reaching
   * Boost or the legacy details-modal; preventDefault cancels the native <details> toggle.
   *
   * Targets: `.header__icon--search` (legacy header) and `.hsearch2026__toggle` (nav 2026). */
  function interceptHeaderSearch(e, doOpen) {
    if (!document.body.classList.contains('search-2026')) return;
    var btn = e.target && e.target.closest('.header__icon--search, .hsearch2026__toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (doOpen) openSearch();
  }
  window.addEventListener('pointerdown', function (e) { interceptHeaderSearch(e, false); }, true);
  window.addEventListener('mousedown', function (e) { interceptHeaderSearch(e, false); }, true);
  window.addEventListener('click', function (e) { interceptHeaderSearch(e, true); }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
